{
  "_format": "hh-sol-artifact-1",
  "contractName": "TokenFTContract",
  "sourceName": "src/backend/contracts/TokenFT.sol",
  "abi": [
    {
      "inputs": [],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "previousAdmin",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "newAdmin",
          "type": "address"
        }
      ],
      "name": "AdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Approval",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "beacon",
          "type": "address"
        }
      ],
      "name": "BeaconUpgraded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "previousOwner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "OwnershipTransferred",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Transfer",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "implementation",
          "type": "address"
        }
      ],
      "name": "Upgraded",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        }
      ],
      "name": "allowance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "approve",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "burn",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "burnFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "decimals",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "subtractedValue",
          "type": "uint256"
        }
      ],
      "name": "decreaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_account",
          "type": "address"
        }
      ],
      "name": "earned",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getAPR",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getReward",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "addedValue",
          "type": "uint256"
        }
      ],
      "name": "increaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_mainContract",
          "type": "address"
        },
        {
          "internalType": "string",
          "name": "_name",
          "type": "string"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "lastUpdateTime",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_payAmount",
          "type": "uint256"
        },
        {
          "internalType": "uint256[]",
          "name": "_zombiesList",
          "type": "uint256[]"
        }
      ],
      "name": "mintMonsterPay",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_sender",
          "type": "address"
        }
      ],
      "name": "myBalance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "proxiableUUID",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "renounceOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "rewardPerToken",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "rewardPerTokenStored",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "rewardRate",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "rewards",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "stake",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stakingDeposits",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stakingEndDateTime",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stakingTotalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "symbol",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transfer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transferFrom",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "transferOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        }
      ],
      "name": "upgradeTo",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "upgradeToAndCall",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "userRewardPerTokenPaid",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "withdraw",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "0x60806040526004361061020d5760003560e01c8063715018a611610118578063a9059cbb116100a0578063d58ea1761161006f578063d58ea176146105db578063dd62ed3e146105f2578063df136d6514610612578063f2fde38b14610629578063f399e22e1461064957600080fd5b8063a9059cbb1461057a578063c89d5b8b1461059a578063c8f33c91146105af578063cd3daf9d146105c657600080fd5b80638b876347116100e75780638b876347146104cf5780638da5cb5b146104fd57806395d89b4114610525578063a457c2d71461053a578063a694fc3a1461055a57600080fd5b8063715018a61461044c57806379cc6790146104615780637b0a47ee14610481578063817a5e141461049857600080fd5b8063313ce5671161019b57806342966c681161016a57806342966c68146103ae5780634f1ef286146103ce57806352d1902d146103e157806370a08231146103f6578063713ea1581461042c57600080fd5b8063313ce5671461034a5780633659cfe61461036657806339509351146103865780633d18b912146103a657600080fd5b8063095ea7b3116101e2578063095ea7b3146102ac57806318160ddd146102dc57806323b872dd146102f15780632d453e92146103115780632e1a7d4d1461032857600080fd5b80624873a8146102125780628cc2621461023c57806306fdde031461025c5780630700037d1461027e575b600080fd5b34801561021e57600080fd5b506102296101365481565b6040519081526020015b60405180910390f35b34801561024857600080fd5b50610229610257366004611d61565b610669565b34801561026857600080fd5b50610271610736565b6040516102339190611da2565b34801561028a57600080fd5b50610229610299366004611d61565b6101336020526000908152604090205481565b3480156102b857600080fd5b506102cc6102c7366004611dd5565b6107c8565b6040519015158152602001610233565b3480156102e857600080fd5b50603554610229565b3480156102fd57600080fd5b506102cc61030c366004611e01565b6107e2565b34801561031d57600080fd5b506102296101355481565b34801561033457600080fd5b50610348610343366004611e42565b610806565b005b34801561035657600080fd5b5060405160128152602001610233565b34801561037257600080fd5b50610348610381366004611d61565b610917565b34801561039257600080fd5b506102cc6103a1366004611dd5565b6109ff565b610348610a21565b3480156103ba57600080fd5b506103486103c9366004611e42565b610afa565b6103486103dc366004611efa565b610b04565b3480156103ed57600080fd5b50610229610bd4565b34801561040257600080fd5b50610229610411366004611d61565b6001600160a01b031660009081526033602052604090205490565b34801561043857600080fd5b50610229610447366004611f5e565b610c87565b34801561045857600080fd5b50610348610dca565b34801561046d57600080fd5b5061034861047c366004611dd5565b610dde565b34801561048d57600080fd5b5061022961012e5481565b3480156104a457600080fd5b506102296104b3366004611d61565b6001600160a01b03166000908152610134602052604090205490565b3480156104db57600080fd5b506102296104ea366004611d61565b6101326020526000908152604090205481565b34801561050957600080fd5b506097546040516001600160a01b039091168152602001610233565b34801561053157600080fd5b50610271610df3565b34801561054657600080fd5b506102cc610555366004611dd5565b610e02565b34801561056657600080fd5b50610348610575366004611e42565b610e7d565b34801561058657600080fd5b506102cc610595366004611dd5565b610f44565b3480156105a657600080fd5b50610229610f52565b3480156105bb57600080fd5b5061022961012f5481565b3480156105d257600080fd5b50610229610f9b565b3480156105e757600080fd5b506102296101315481565b3480156105fe57600080fd5b5061022961060d366004612010565b61100f565b34801561061e57600080fd5b506102296101305481565b34801561063557600080fd5b50610348610644366004611d61565b61103a565b34801561065557600080fd5b50610348610664366004611efa565b6110b0565b6001600160a01b038116600090815261013460205260408120541515806106a857506001600160a01b0382166000908152610133602052604090205415155b1561072e576001600160a01b03821660009081526101336020908152604080832054610132909252822054670de0b6b3a7640000906106e5610f9b565b6106ef919061205f565b6001600160a01b038616600090815261013460205260409020546107139190612072565b61071d9190612089565b61072791906120ab565b9392505050565b506000919050565b606060368054610745906120be565b80601f0160208091040260200160405190810160405280929190818152602001828054610771906120be565b80156107be5780601f10610793576101008083540402835291602001916107be565b820191906000526020600020905b8154815290600101906020018083116107a157829003601f168201915b5050505050905090565b6000336107d68185856112b4565b60019150505b92915050565b6000336107f08582856113d8565b6107fb858585611452565b506001949350505050565b3361080f610f9b565b610130554261012f5561082181610669565b6001600160a01b038216600090815261013360209081526040808320939093556101305461013290915291812091909155610131805484929061086590849061205f565b909155505033600090815261013460205260408120805484929061088a90849061205f565b925050819055508161013560008282546108a4919061205f565b909155505060405163a9059cbb60e01b815233600482015260248101839052309063a9059cbb906044015b6020604051808303816000875af11580156108ee573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061091291906120f8565b505050565b6001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001630036109685760405162461bcd60e51b815260040161095f9061211a565b60405180910390fd5b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166109b16000805160206124b4833981519152546001600160a01b031690565b6001600160a01b0316146109d75760405162461bcd60e51b815260040161095f90612166565b6109e0816115fd565b604080516000808252602082019092526109fc91839190611605565b50565b6000336107d6818585610a12838361100f565b610a1c91906120ab565b6112b4565b33610a2a610f9b565b610130554261012f55610a3c81610669565b6001600160a01b03821660009081526101336020908152604080832093909355610130546101329091529190205567016345785d8a0000341015610ab95760405162461bcd60e51b815260206004820152601460248201527315dc9bdb99c81c185e5b595b9d08185b5bdd5b9d60621b604482015260640161095f565b336000818152610133602052604080822080549290555163a9059cbb60e01b815260048101929092526024820181905290309063a9059cbb906044016108cf565b6109fc3382611770565b6001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000163003610b4c5760405162461bcd60e51b815260040161095f9061211a565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316610b956000805160206124b4833981519152546001600160a01b031690565b6001600160a01b031614610bbb5760405162461bcd60e51b815260040161095f90612166565b610bc4826115fd565b610bd082826001611605565b5050565b6000306001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610c745760405162461bcd60e51b815260206004820152603860248201527f555550535570677261646561626c653a206d757374206e6f742062652063616c60448201527f6c6564207468726f7567682064656c656761746563616c6c0000000000000000606482015260840161095f565b506000805160206124b483398151915290565b6000808311610ccf5760405162461bcd60e51b815260206004820152601460248201527315dc9bdb99c81c185e5b595b9d08185b5bdd5b9d60621b604482015260640161095f565b61012d546040805163f095821f60e01b815290516000926001600160a01b03169163f095821f9160048083019260209291908290030181865afa158015610d1a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d3e91906121b2565b90506000816001600160a01b031663489cb8208686336040518463ffffffff1660e01b8152600401610d72939291906121cf565b6020604051808303816000875af1158015610d91573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610db59190612232565b9050610dc13086610f44565b50949350505050565b610dd26118a4565b610ddc60006118fe565b565b610de98233836113d8565b610bd08282611770565b606060378054610745906120be565b60003381610e10828661100f565b905083811015610e705760405162461bcd60e51b815260206004820152602560248201527f45524332303a2064656372656173656420616c6c6f77616e63652062656c6f77604482015264207a65726f60d81b606482015260840161095f565b6107fb82868684036112b4565b33610e86610f9b565b610130554261012f55610e9881610669565b6001600160a01b038216600090815261013360209081526040808320939093556101305461013290915291812091909155610131549003610ee657610ee1426304a286006120ab565b610136555b816101316000828254610ef991906120ab565b9091555050336000908152610134602052604081208054849290610f1e9084906120ab565b92505081905550816101356000828254610f3891906120ab565b90915550610912905030835b6000336107d6818585611452565b6101315460009015610f9557610131546301e133809081610f7b81670de0b6b3a7640000612072565b610f859190612072565b610f8f9190612089565b91505090565b50600090565b600061013154600003610fb057506101305490565b61012f5461013654811115610fc55750610136545b6101315461012e5461012f54610fdb904261205f565b610fe59190612072565b610ff790670de0b6b3a7640000612072565b6110019190612089565b61013054610f8f91906120ab565b6001600160a01b03918216600090815260346020908152604080832093909416825291909152205490565b6110426118a4565b6001600160a01b0381166110a75760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b606482015260840161095f565b6109fc816118fe565b600054610100900460ff16158080156110d05750600054600160ff909116105b806110ea5750303b1580156110ea575060005460ff166001145b61114d5760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b606482015260840161095f565b6000805460ff191660011790558015611170576000805461ff0019166101001790555b61119960405180604001604052806007815260200166169bdb5b185b9960ca1b81525083611950565b6111a1611981565b6111a96119a8565b6111b1611981565b61012d80546001600160a01b0319166001600160a01b038516179055670de0b6b3a764000061012e55600060126111e990600a61232f565b6111f790633b9aca00612072565b905060006112076012600a61232f565b611215906304c4b400612072565b905060006112256012600a61232f565b61123390631312d000612072565b90506112533382611244858761205f565b61124e919061205f565b6119d7565b61125d30836119d7565b61126786826119d7565b5050508015610912576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a1505050565b6001600160a01b0383166113165760405162461bcd60e51b8152602060048201526024808201527f45524332303a20617070726f76652066726f6d20746865207a65726f206164646044820152637265737360e01b606482015260840161095f565b6001600160a01b0382166113775760405162461bcd60e51b815260206004820152602260248201527f45524332303a20617070726f766520746f20746865207a65726f206164647265604482015261737360f01b606482015260840161095f565b6001600160a01b0383811660008181526034602090815260408083209487168084529482529182902085905590518481527f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925910160405180910390a3505050565b60006113e4848461100f565b9050600019811461144c578181101561143f5760405162461bcd60e51b815260206004820152601d60248201527f45524332303a20696e73756666696369656e7420616c6c6f77616e6365000000604482015260640161095f565b61144c84848484036112b4565b50505050565b6001600160a01b0383166114b65760405162461bcd60e51b815260206004820152602560248201527f45524332303a207472616e736665722066726f6d20746865207a65726f206164604482015264647265737360d81b606482015260840161095f565b6001600160a01b0382166115185760405162461bcd60e51b815260206004820152602360248201527f45524332303a207472616e7366657220746f20746865207a65726f206164647260448201526265737360e81b606482015260840161095f565b6001600160a01b038316600090815260336020526040902054818110156115905760405162461bcd60e51b815260206004820152602660248201527f45524332303a207472616e7366657220616d6f756e7420657863656564732062604482015265616c616e636560d01b606482015260840161095f565b6001600160a01b0380851660008181526033602052604080822086860390559286168082529083902080548601905591517fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef906115f09086815260200190565b60405180910390a361144c565b6109fc6118a4565b7f4910fdfa16fed3260ed0e7147f7cc6da11a60208b5b9406d12a635614ffd91435460ff16156116385761091283611a98565b826001600160a01b03166352d1902d6040518163ffffffff1660e01b8152600401602060405180830381865afa925050508015611692575060408051601f3d908101601f1916820190925261168f91810190612232565b60015b6116f55760405162461bcd60e51b815260206004820152602e60248201527f45524331393637557067726164653a206e657720696d706c656d656e7461746960448201526d6f6e206973206e6f74205555505360901b606482015260840161095f565b6000805160206124b483398151915281146117645760405162461bcd60e51b815260206004820152602960248201527f45524331393637557067726164653a20756e737570706f727465642070726f786044820152681a58589b195555525160ba1b606482015260840161095f565b50610912838383611b34565b6001600160a01b0382166117d05760405162461bcd60e51b815260206004820152602160248201527f45524332303a206275726e2066726f6d20746865207a65726f206164647265736044820152607360f81b606482015260840161095f565b6001600160a01b038216600090815260336020526040902054818110156118445760405162461bcd60e51b815260206004820152602260248201527f45524332303a206275726e20616d6f756e7420657863656564732062616c616e604482015261636560f01b606482015260840161095f565b6001600160a01b03831660008181526033602090815260408083208686039055603580548790039055518581529192917fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef910160405180910390a3505050565b6097546001600160a01b03163314610ddc5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015260640161095f565b609780546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b600054610100900460ff166119775760405162461bcd60e51b815260040161095f9061233e565b610bd08282611b59565b600054610100900460ff16610ddc5760405162461bcd60e51b815260040161095f9061233e565b600054610100900460ff166119cf5760405162461bcd60e51b815260040161095f9061233e565b610ddc611b99565b6001600160a01b038216611a2d5760405162461bcd60e51b815260206004820152601f60248201527f45524332303a206d696e7420746f20746865207a65726f206164647265737300604482015260640161095f565b8060356000828254611a3f91906120ab565b90915550506001600160a01b0382166000818152603360209081526040808320805486019055518481527fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef910160405180910390a35050565b6001600160a01b0381163b611b055760405162461bcd60e51b815260206004820152602d60248201527f455243313936373a206e657720696d706c656d656e746174696f6e206973206e60448201526c1bdd08184818dbdb9d1c9858dd609a1b606482015260840161095f565b6000805160206124b483398151915280546001600160a01b0319166001600160a01b0392909216919091179055565b611b3d83611bc9565b600082511180611b4a5750805b156109125761144c8383611c09565b600054610100900460ff16611b805760405162461bcd60e51b815260040161095f9061233e565b6036611b8c83826123d7565b50603761091282826123d7565b600054610100900460ff16611bc05760405162461bcd60e51b815260040161095f9061233e565b610ddc336118fe565b611bd281611a98565b6040516001600160a01b038216907fbc7cd75a20ee27fd9adebab32041f755214dbc6bffa90cc0225b39da2e5c2d3b90600090a250565b606061072783836040518060600160405280602781526020016124d4602791396060600080856001600160a01b031685604051611c469190612497565b600060405180830381855af49150503d8060008114611c81576040519150601f19603f3d011682016040523d82523d6000602084013e611c86565b606091505b5091509150611c9786838387611ca1565b9695505050505050565b60608315611d10578251600003611d09576001600160a01b0385163b611d095760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e7472616374000000604482015260640161095f565b5081611d1a565b611d1a8383611d22565b949350505050565b815115611d325781518083602001fd5b8060405162461bcd60e51b815260040161095f9190611da2565b6001600160a01b03811681146109fc57600080fd5b600060208284031215611d7357600080fd5b813561072781611d4c565b60005b83811015611d99578181015183820152602001611d81565b50506000910152565b6020815260008251806020840152611dc1816040850160208701611d7e565b601f01601f19169190910160400192915050565b60008060408385031215611de857600080fd5b8235611df381611d4c565b946020939093013593505050565b600080600060608486031215611e1657600080fd5b8335611e2181611d4c565b92506020840135611e3181611d4c565b929592945050506040919091013590565b600060208284031215611e5457600080fd5b5035919050565b634e487b7160e01b600052604160045260246000fd5b604051601f8201601f1916810167ffffffffffffffff81118282101715611e9a57611e9a611e5b565b604052919050565b600067ffffffffffffffff831115611ebc57611ebc611e5b565b611ecf601f8401601f1916602001611e71565b9050828152838383011115611ee357600080fd5b828260208301376000602084830101529392505050565b60008060408385031215611f0d57600080fd5b8235611f1881611d4c565b9150602083013567ffffffffffffffff811115611f3457600080fd5b8301601f81018513611f4557600080fd5b611f5485823560208401611ea2565b9150509250929050565b60008060408385031215611f7157600080fd5b8235915060208084013567ffffffffffffffff80821115611f9157600080fd5b818601915086601f830112611fa557600080fd5b813581811115611fb757611fb7611e5b565b8060051b9150611fc8848301611e71565b8181529183018401918481019089841115611fe257600080fd5b938501935b8385101561200057843582529385019390850190611fe7565b8096505050505050509250929050565b6000806040838503121561202357600080fd5b823561202e81611d4c565b9150602083013561203e81611d4c565b809150509250929050565b634e487b7160e01b600052601160045260246000fd5b818103818111156107dc576107dc612049565b80820281158282048414176107dc576107dc612049565b6000826120a657634e487b7160e01b600052601260045260246000fd5b500490565b808201808211156107dc576107dc612049565b600181811c908216806120d257607f821691505b6020821081036120f257634e487b7160e01b600052602260045260246000fd5b50919050565b60006020828403121561210a57600080fd5b8151801515811461072757600080fd5b6020808252602c908201527f46756e6374696f6e206d7573742062652063616c6c6564207468726f7567682060408201526b19195b1959d85d1958d85b1b60a21b606082015260800190565b6020808252602c908201527f46756e6374696f6e206d7573742062652063616c6c6564207468726f7567682060408201526b6163746976652070726f787960a01b606082015260800190565b6000602082840312156121c457600080fd5b815161072781611d4c565b6000606082018583526020606081850152818651808452608086019150828801935060005b81811015612210578451835293830193918301916001016121f4565b50506001600160a01b0395909516604094909401939093525091949350505050565b60006020828403121561224457600080fd5b5051919050565b600181815b8085111561228657816000190482111561226c5761226c612049565b8085161561227957918102915b93841c9390800290612250565b509250929050565b60008261229d575060016107dc565b816122aa575060006107dc565b81600181146122c057600281146122ca576122e6565b60019150506107dc565b60ff8411156122db576122db612049565b50506001821b6107dc565b5060208310610133831016604e8410600b8410161715612309575081810a6107dc565b612313838361224b565b806000190482111561232757612327612049565b029392505050565b600061072760ff84168361228e565b6020808252602b908201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960408201526a6e697469616c697a696e6760a81b606082015260800190565b601f82111561091257600081815260208120601f850160051c810160208610156123b05750805b601f850160051c820191505b818110156123cf578281556001016123bc565b505050505050565b815167ffffffffffffffff8111156123f1576123f1611e5b565b612405816123ff84546120be565b84612389565b602080601f83116001811461243a57600084156124225750858301515b600019600386901b1c1916600185901b1785556123cf565b600085815260208120601f198616915b828110156124695788860151825594840194600190910190840161244a565b50858210156124875787850151600019600388901b60f8161c191681555b5050505050600190811b01905550565b600082516124a9818460208701611d7e565b919091019291505056fe360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc416464726573733a206c6f772d6c6576656c2064656c65676174652063616c6c206661696c6564a26469706673582212204b5e47ad7a852d00842b00579a7c15429e8c586593445a8927237209ccd9553664736f6c63430008150033",
  "linkReferences": {},
  "deployedLinkReferences": {}
}